import { JaneDetailsModalComponentMap } from './JaneDetailsModal.constants';
import { JaneDetailsModalViewType } from './JaneDetailsModal.constants';

import { useURLParameters } from 'hooks';
import { createContext, FC, useContext, useEffect } from 'react';

export interface IJaneDetailsModalUI {
  isOpen: boolean;
  janeId?: string;
  janeDetailsModalActiveModalView: JaneDetailsModalViewType;
}

export const JaneDetailsModalUIContext = createContext<IJaneDetailsModalUI>({
  isOpen: false,
  janeId: undefined as IJaneDetailsModalUI['janeId'],
  janeDetailsModalActiveModalView: 'JaneDetailsView' as JaneDetailsModalViewType,
});

export const JaneDetailsModalUIProvider: FC = ({ children }) => {
  const [{ janeId: janeDetailsModalJaneId, janeDetailsModalActiveModalView }, { removeParam }] =
    useURLParameters<{
      janeDetailsModalJaneId?: string;
      janeDetailsModalActiveModalView: JaneDetailsModalViewType;
    }>();

  const janeId = janeDetailsModalJaneId ? janeDetailsModalJaneId : undefined;
  useEffect(() => {
    if (!Object.keys(JaneDetailsModalComponentMap).includes(janeDetailsModalActiveModalView)) {
      removeParam(['janeDetailsModalActiveModalView', 'janeDetailsModalJaneId']);
    }
    if (!janeId && janeDetailsModalActiveModalView) {
      removeParam('janeDetailsModalActiveModalView');
    }
  }, [removeParam, janeDetailsModalActiveModalView, janeId]);

  return (
    <JaneDetailsModalUIContext.Provider
      value={{
        isOpen: !!janeDetailsModalActiveModalView,
        janeDetailsModalActiveModalView,
        janeId,
      }}
    >
      {children}
    </JaneDetailsModalUIContext.Provider>
  );
};

export const useJaneDetailsModalUIContext = () => useContext(JaneDetailsModalUIContext);
